import { isLoadingSelector, isUpdatedSelector, errorSelector } from '../utils/helperSelectors';
const reducerName = 'emailVerification';
export const isEmailVerificationLoadingSelector = isLoadingSelector(reducerName);
export const isEmailVerificationUpdatedSelector = isUpdatedSelector(reducerName);
export const emailVerificationErrorSelector = errorSelector(reducerName);
export const emailVerificationSelector = (state) => state[reducerName].data;
//# sourceMappingURL=selectors.js.map